module.exports = __webpack_public_path__ + "img/forge-icon-black.49d5fe61.svg";